<template>
  <div class="main-content-container container-fluid px-4">
     <loading :active.sync="isLoading" 
        :can-cancel="false" 
        :loader='"dots"'
        :height='150'
        :width='150'
        :color= '"#F1557A"'
        :is-full-page="fullPage"></loading>
    <v-dialog />
    <!-- Page Header -->

    <div class="page-header row no-gutters py-4">
      <div class="col-lg-8 col-sm-4 text-center text-sm-left mb-0">
        <span class="text-uppercase page-subtitle">Power Editor</span>
        <h3 class="page-title">To Dos</h3>
      </div>
      <!-- <div class="col-lg-2 col-sm-2 mb-0">
        <d-button class="btn-red btn-right" @click="deletesupporter">
          <i class="material-icons">delete</i> Delete
        </d-button>
      </div>
      <div class="col-lg-2 col-sm-2 mb-0">
        <d-button class="btn-blue btn-right" @click="openModal">
          <i class="material-icons">edit</i> Edit
        </d-button>
      </div>-->
    </div>
    <sweet-modal ref="modal">
      <strong class="text-muted text-left d-block mb-2">Select Supporters</strong>
      <d-input-group class="mb-3">
        <multiselect
          :close-on-select="false"
          placeholder
          label="name"
          v-model="selectedSupporter"
          :multiple="true"
          track-by="name"
          :options="options"
        ></multiselect>
      </d-input-group>
      <strong class="text-muted text-left d-block mb-2">Select a User</strong>
      <d-input-group class="mb-3">
        <d-select :value="selectedUser" @change="onchangeUser">
          <option>Select</option>
          <option
            v-for="(employee, index) in allEmployees"
            :key="index"
            v-bind:value="employee._id"
          >{{ employee.first_name + " " + employee.last_name }}</option>
        </d-select>
      </d-input-group>
      <strong class="text-muted text-left d-block mb-2">Select a Call-To-Action</strong>
      <d-input-group class="mb-3">
        <d-select :value="selectedCTA" @change="onchangeCta">
          <option>Support our new campaign - One-Time Donation</option>
          <option
            v-if="allCTA.length > 0"
            v-for="(cta, index) in allCTA"
            :key="index"
            v-bind:value="cta.id"
          >{{ cta.title + " - " + cta.type }}</option>
        </d-select>
      </d-input-group>
      <br />
      <br />
      <d-button @click.prevent="editTodo()" class="btn-blue btn-right">Edit</d-button>
    </sweet-modal>

    <!-- Default Light Table -->
    <div class="row">
      <div class="col">
        <div class="card card-small mb-4">
          <vue-good-table
            class="card-style"
            :columns="columns"
            :rows="rows"
            @on-row-click="onRowClick"
            @on-select-all="onSelectAll"
            :pagination-options="{
              enabled: false,
              mode: 'records',
              perPage: 25,
              position: 'top',
              perPageDropdown: [5, 10, 25],
              dropdownAllowAll: false,
              setCurrentPage: 2,
              nextLabel: 'next',
              prevLabel: 'prev',
              rowsPerPageLabel: 'To Dos per page',
              ofLabel: 'of',
              pageLabel: 'page', // for 'pages' mode
              allLabel: 'All'
            }"
            :selectOptions="{
              enabled: false,
              selectOnCheckboxOnly: false, // only select when checkbox is clicked instead of the row
              selectionInfoClass: 'custom-class',
              selectionText: 'rows selected',
              clearSelectionText: 'clear',
              disableSelectInfo: false // disable the select info panel on top
            }"
          >
            <template slot="table-row" slot-scope="props">
              <div v-if="props.column.field == 'modify'">
                <div style="display:flex;justify-content: flex-start">
                  <d-button class="btn-blue mb-1" style="width:100px;" @click="openModal(props)">Edit</d-button>
                </div>
                <div style="display:flex;justify-content: flex-start">
                  <d-button class="btn-red mb-1" style="width:100px;" @click="deletesupporter(props)">Delete</d-button>
                </div>
              </div>

              <span v-else>{{ props.formattedRow[props.column.field] }}</span>
            </template>
          </vue-good-table>
        </div>
        <d-col class="text-right view-report" style="margin-botton:15px;">
          <download-csv :data="todos" name="givemagic_export.csv">
            <a href="#">Export csv report</a>
          </download-csv>
        </d-col>
      </div>
      </div>
      <d-row class="pagination-row">
       <d-col  class="pagination-col">
        <!-- <span class="load-more">
          <d-button class=" btn-primary2" @click="loadMoreVideos()">Next<i class="material-icons">launch</i></d-button>
        </span> -->
        <nav aria-label="Page navigation example">
       	<ul class="pagination ul">
				<li class="page-item">
				 <button type="button" class="page-link" v-if="page != 1" @click="loadPreviousVideos()"> Previous </button>
				</li>
				<li>
          <button type="button" v-if="this.nextPage"  @click="loadMoreVideos()"  class="page-link"> Next </button>
				</li>
			</ul>
        </nav>
        </d-col>
      </d-row>
    </div>
  </div>
</template>
<script>
import supportersTypes from "../vuex/supporters/supporters.types";
import managerTypes from "../vuex/manager/manager.types";
import Multiselect from "vue-multiselect";
import todosTypes from "../vuex/todos/todos.types";
import ctaTypes from "../vuex/cta/cta.types";
import DownloadCsv from "vue-json-csv";
import moment from "moment";
import "vue-good-table/dist/vue-good-table.css";
import { VueGoodTable } from "vue-good-table";
import { SweetModal, SweetModalTab } from "sweet-modal-vue";
import { mapState } from "vuex";
import Vue from "vue";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
// import "quill/dist/quill.snow.css";
Vue.use(Loading);
export default {
  data() {
    return {
    prevPage:null,
      page:1,
      nextPage: null,
      isLoading: false,
      todos: [],
      selectedSupporter: [],
      options: [],
      selectedUser: null,
      supporters: [],
      allEmployees: [],
      fullPage: true,
      selectedTodos: [],
      selectedCTA: null,
      allCTA: [],
      columns: [
        {
          label: "Supporters",
          field: "names"
        },
        {
          label: "Call-To-Action",
          field: "cta",
          type: "text"
        },
        {
          label: "CTA Type",
          field: "cta_type",
          type: "text"
        },
        {
          label: "User",
          field: "assign",
          type: "text"
        },
        {
          label: "Date Created",
          field: "date_created",
          type: "text"
          // dateInputFormat: 'yyyy-MM-dd',
          // dateOutputFormat: 'MMM Do yy',
        },
        {
          label: "Modify",
          field: "modify",
          html: true
        }
      ],
      rows: []
    };
  },
  computed: {
    ...mapState({
      state: state => state.supporters.state,
      type: state => state.supporters.type,
      supporterData: state => state.supporters.data,
      todotype: state => state.todos.type,
      updatedTodo: state => state.todos.update,
      ctaType: state => state.cta.type,
      clientType: state => state.manager.type,
      employees: state => state.manager.data,
      todoDeleted: state => state.todos.deleted,
      data: state => state.todos.data,
      ctas: state => state.cta.data,
      error: state => state.supporters.error,
      todoerror: state => state.todos.error
    })
  },
  methods: {
loadMoreVideos() {
      // this.loadNum = this.loadNum + 8;
      if(this.nextPage){
        this.rows=[]
        const  data = this.nextPage
        this.$store.dispatch("fetchTodos" , data)
      }
    },
    loadPreviousVideos(){
      if(this.prevPage){
        this.rows=[]
        const  data = this.prevPage
        this.$store.dispatch("fetchTodos" , data)
      }
    },
    onchangeCta(cta) {
      if (cta != "Support our new campaign - One-Time Donation") {
        this.selectedCTA = cta;
      } else {
        this.selectedCTA = null;
      }
    },
    onchangeUser(user) {
      if (user != "Select") {
        this.selectedUser = user;
      } else {
        this.selectedUser = null;
      }
    },
    openModal(selected) {
      this.selectedSupporter = [];
      let eachsupporter = selected.row.supporters;
      let save = selected.row;

      for (var i = 0; i < eachsupporter.length; i++) {
        var first_name = eachsupporter[i].first_name;
        var last_name = eachsupporter[i].last_name;
        var id = eachsupporter[i]._id;
        this.selectedSupporter.push({
          name: `${first_name} ${last_name}`,
          id
        });
      }
      this.selectedCTA = selected.row.ctaId._id;
      this.selectedUser = selected.row.assigned_to._id;
      this.selectRow = save;
      this.$refs.modal.open();
    },
    formatFn: function(value) {
      return "$" + value;
    },
    onRowClick(row) {
      if (row.selected) {
        this.selectedTodos.push(row.row);
      } else {
        for (var i = 0; i < this.selectedTodos.length; i++) {
          const eachsupporter = this.selectedTodos[i];
          if (eachsupporter._id == row.row._id) {
            this.selectedTodos.splice(i, 1);
          }
        }
      }
    },
    onSelectAll(selectAll) {
      if (selectAll.selected) {
        this.selectedTodos = selectAll.selectedRows;
      } else {
        this.selectedTodos = [];
      }
    },
    csvFieds(value, key) {
    },
    dateFormat(value) {
      return moment(String(value)).format("MM/DD/YYYY hh:mm");
    },
    deleteTodo(selectedTodo) {
      if (selectedTodo) {
        this.$store.dispatch("deleteTodosRequest", selectedTodo);
      }
    },
    fetchSupporters(supporter, length) {
      if (!supporter.length) return `No Supporters`;
      switch (length) {
        case 1:
          return `${supporter[0].first_name}`;
          break;
        case 2:
          return `${supporter[0].first_name} & ${supporter[1].first_name}`;
          break;
        case 3:
          return `${supporter[0].first_name} , ${supporter[1].first_name} & 1 other`;
          break;
        default:
          return `${supporter[0].first_name} , ${
            supporter[1].first_name
          } & ${length - 2} others`;
          break;
      }
    },
    deletesupporter(supporter) {
      const modal = this.$modal;
      const that = this;
      modal.show("dialog", {
        title: "Confirm delete",
        text: "Are you sure you want to delete this Todo?",
        buttons: [
          {
            title: "Cancel",
            handler: () => {
              modal.hide("dialog");
            }
          },
          {
            title: "Delete",
            handler: () => {
              // that.$store.dispatch("deletesupporter", supporter);
              this.deleteTodo(supporter.row);
              modal.hide("dialog");
            },
            class: "vue-dialog-button delete-btn"
          }
        ]
      });
    },
    editTodo() {
      if (
        this.selectedUser &&
        this.selectedCTA &&
        this.selectedSupporter &&
        this.selectedSupporter.length
      ) {
        this.$refs.modal.close();
        var supporters = [];
        this.selectedSupporter.map(item => supporters.push(item.id));
        let obj = {
          id: this.selectRow._id,
          ctaId: this.selectedCTA,
          assigned_to: this.selectedUser,
          supporters
        };
        this.$store.dispatch("editTodo", obj);
      }
    }
  },
  watch: {
    ctaType(type) {
      if (type == ctaTypes.FETCH_CTAS_SUCCESS) {
        this.allCTA = this.ctas.actions;
      }
    },
    clientType(type) {
      if (type === managerTypes.FETCH_manager_SUCCESS) {
        this.allEmployees = this.employees.employees;
      }
    },
    todotype(type) {
      if (type === todosTypes.DELETE_TODOS_REQUEST) {
        // this.isLoading = true;
        const  data = this.page
        this.$store.dispatch("fetchTodos",data);
        // this.$toasted.info("Deleting Todo...", {
        //   icon: "hourglass_empty",
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
      } else if (type === todosTypes.UPDATE_TODOS_REQUEST) {
        // this.isLoading = true;
        // this.$toasted.info("Updating Todo...", {
        //   icon: "hourglass_empty",
        //   duration: 1000,
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
      } else if (type === todosTypes.UPDATE_TODOS_SUCCESS) {
        this.isLoading = false;
        this.$toasted.success("Todo updated", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
        this.rows.map((item, index) => {
          if (item._id == this.updatedTodo.todos._id) {
            const updateTodo = this.updatedTodo.todos;
            this.rows.splice(index, 1, {
              names: `${updateTodo.supporters &&
                this.fetchSupporters(
                  updateTodo.supporters,
                  updateTodo.supporters.length
                )}`,
              cta: updateTodo.cta ? updateTodo.cta.description : "n/a",
              cta_type: updateTodo.cta ? updateTodo.cta.type : "n/a",
              assign: updateTodo.assigned_to
                ? updateTodo.assigned_to.first_name
                : "n/a",
              date_created: moment(updateTodo.createdAt).format(
                "MM/DD/YYYY hh:mm"
              ),
              supporters: updateTodo.supporters,
              _id: updateTodo._id,
              ctaId: updateTodo.cta,
              assigned_to: updateTodo.assigned_to
            });
          }
        });
      } else if (type === todosTypes.UPDATE_TODOS_FAILED) {
        this.isLoading = false;
        this.$toasted.error(this.todoerror, {
          icon: "error_outline",
          keepOnHover: true,
          duration: 3000,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (type === todosTypes.DELETE_TODOS_SUCCESS) {
        this.isLoading = false;
        for (var i = 0; i < this.rows.length; i++) {
          const eachTodo = this.rows[i];
          if (eachTodo._id == this.todoDeleted.todo._id) {
            this.rows.splice(i, 1);
          }
        }
        this.$toasted.clear();
        this.$toasted.success("Todo deleted", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
        this.selectedTodos = [];
        //window.location.reload();
      } else if (type === todosTypes.FETCH_TODOS_SUCCESS) {
        var todosuncompleted = []
        this.page = this.data.todos.page
        this.nextPage = this.data.todos.nextPage
        this.prevPage= this.data.todos.prevPage
        const todo = this.data.todos.docs
        todo.map((i)=>{
          if(i.status === 'uncompleted'){
            todosuncompleted.push(i);
          }
        })
        // this.todos = todosuncompleted;
        this.isLoading = false;
        this.supporters = this.data.supporters;
        if (todosuncompleted && todosuncompleted.length) {
          for (var i = 0; i < todosuncompleted.length; i++) {
            let eachsupporter = todosuncompleted[i];
            this.rows.push({
              names: `${eachsupporter.supporters &&
                this.fetchSupporters(
                  eachsupporter.supporters,
                  eachsupporter.supporters.length
                )}`,
              cta: eachsupporter.cta ? eachsupporter.cta.description : "n/a",
              cta_type: eachsupporter.cta ? eachsupporter.cta.type : "n/a",
              assign: eachsupporter.assigned_to
                ? eachsupporter.assigned_to.first_name
                : "n/a",
              date_created: moment(eachsupporter.createdAt).format(
                "MM/DD/YYYY hh:mm"
              ),
              supporters: eachsupporter.supporters,
              // edit:  `<input type="button" onClick=onClickAction() value="hello">`,
              // delete: this.btn('Delete',eachsupporter,this),
              _id: eachsupporter._id,
              ctaId: eachsupporter.cta,
              assigned_to: eachsupporter.assigned_to
            });
          }
        }
        this.$toasted.clear();
      } else if (type === todosTypes.FETCH_TODOS_REQUEST) {
        this.isLoading = true;
        // this.$toasted.info("Fetching To Dos...", {
        //   icon: "hourglass_empty",
        //   duration: 1000,
        //   fullWidth: false,
        //   keepOnHover: true,
        //   singleton: true,
        //   action: {
        //     text: "Close",
        //     onClick: (e, toastObject) => {
        //       toastObject.goAway(0);
        //     }
        //   }
        // });
      }
    },
    type(newType) {
      if (newType === supportersTypes.DELETE_supporter_SUCCESS) {
        this.$toasted.clear();
        this.$toasted.success("supporter deleted", {
          position: "top-center",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
        //window.location.reload();
      } else if (newType === supportersTypes.FETCH_supporterS_SUCCESS) {
        let allSupporters = this.supporterData.supporters;
        if (allSupporters && allSupporters.length) {
          allSupporters.map(item => {
            this.options.push({
              name: `${item.first_name} ${item.last_name}`,
              id: item._id
            });
          });
        }
      } else if (newType === supportersTypes.DELETE_supporter_REQUEST) {
        this.$toasted.info("Deleting To Dos...", {
          icon: "hourglass_empty",
          duration: 1000,
          fullWidth: false,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (newType === supportersTypes.FETCH_supporter_FAILED) {
        this.$toasted.error(this.error, {
          icon: "error_outline",
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      } else if (newType === supportersTypes.DELETE_supporter_FAILED) {
        this.$toasted.clear();
        this.$modal.hide("dialog");
        this.$toasted.error(this.error, {
          icon: "error_outline",
          //duration: 1000,
          keepOnHover: true,
          singleton: true,
          action: {
            text: "Close",
            onClick: (e, toastObject) => {
              toastObject.goAway(0);
            }
          }
        });
      }
    }
  },
  components: {
    DownloadCsv,
    VueGoodTable,
    SweetModal,
    SweetModalTab,
    Multiselect,
    Loading
  },
  created() {
     const  data = 1
    this.$store.dispatch("fetchTodos",data);
    this.$store.dispatch("fetchsupporters");
    this.$store.dispatch("fetchAllCTA");
    this.$store.dispatch("fetchAllEmployees");
    analytics.page("To dos");
  }
};
</script>
<style lang="scss">
@import "../dist/vue-multiselect.min.css";
 button.page-link {
	display: inline-block;
}

.ul{
  display: flex;
  justify-content: center;
}
button.page-link {
    border-color: #f6f6f6;
  background: linear-gradient(#f4f5f8, #f1f3f6) !important;
  background-color: #ffffff00;
  color: #232349;
  box-shadow: 0 1px 2px rgba(#232349, 0.3), inset 0 1px 0 #fff !important;
  font-size: 14px;
  text-transform: uppercase;
  font-weight: 800;
  box-shadow: none;
  border-radius: 5px;
  border-color: none;
  :hover {
    // border-color: #232349 !important;
    // background-color: #232349 !important;
    // color: #232349 !important;
    box-shadow: none !important;
  }
  :active {
    border-color: #f2557a;
    background-color: #f2557a;
  }
}
.offset{
  width: 500px !important;
  margin: 20px auto;  
}
.pagination-row{
  // background-color: #56dd44;
  height: 100%
  }
  .pagination-col{
    // background-color: #dd4484;
   height: 100%;
   align-items: center
   
  }
.btn-right {
  width: 150px;
  height: 50px;
  float: right;
  font-size: 16px;
}

.btn-red {
  background: #dd4b44;
  border: #dd4b44;
  color: #dd4b44 !important;
  &:hover {
    background: #de3b34;
  }
}
.btn-Green {
  background: #dd4b44;
  border: #dd4b44;
  color: #56dd44 !important;
  &:hover {
    background: #de3b34;
  }
}

.vue-dialog-button.delete-btn {
  background: #dd4b44;
  color: white;

  &:hover {
    background: #de3b34;
  }
}
.profile-pic {
  max-width: 50px;
  max-height: 50px;
  border-radius: 5px;
}
table td {
  font-size: 12px;
}
td,
th {
  padding: 0.125em 0.5em 0.25em;
  line-height: 1.2;
}
th {
  padding: 0.75rem;
}
tr:nth-child(even) {
  background-color: #f2f2f2;
}
.fig-table {
  max-width: 100%;
  overflow-x: scroll;
}
.table td {
  text-align: center;
  vertical-align: middle;
  .material-icons {
    font-size: 1rem;
    cursor: pointer;
  }
  .edit-icon {
    color: royalblue;
  }
  .delete-icon-wrapper {
    margin-left: 10px;
    .delete-icon {
      color: red;
    }
  }
}
.table thead th {
  text-align: left;
  vertical-align: middle;
}
.multiselect__tag {
  background: #2a2d3a !important;
  font-size: 1rem !important;
  padding: 6px 26px 6px 10px !important;
}
.sweet-modal .sweet-box-actions .sweet-action-close:hover {
  background: #2a2d3a;
  color: #fff;
}

.multiselect__option .multiselect__option--selected {
  background: #2a2d3a;
  outline: none;
  color: #fff;
}
.multiselect__tag-icon:after {
  color: #fff !important;
  font-size: 16px !important;
}
.custom-select {
  font-size: 1rem;
}
</style>
